export enum NotConfidentReason {
  // Der Zug ist sicher
  None = 0,

  // Der Letzte Zug ist immer auffällig
  LastMove = 1 << 0,

  // Züge mit Verschiebungen sind auffällig
  Shifted = 1 << 1,

  // Züge die manuell gesetzt wurden sind auffällig
  ManualSelection = 1 << 2,

  // Kein Zug konnte erkannt werden
  NoMoveRecognized = 1 << 3,

  // Der wahrscheinlichste Zug hat eine miserable Erkennung
  BadRecognition = 1 << 4,

  // Der aktuell ausgewühlte Zug ist nicht der wahrscheinlichste Zug
  NotMostLikelyMove = 1 << 5,

  // Es gibt mehrere Züge mit dem gleichen letztzen erkannten Zug
  AtLeastTwoMovesWithSameLastRecognizedMove = 1 << 6,

  // Ein Zug reduzoert die möglichen Bretter überdurchschnittlich stark
  StrongBoardReduction = 1 << 7,

  // Es gibt mehrere Züge die gleich wahrscheinlich sind
  MultipleLikelyMoves = 1 << 8
}
